import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";

const STATUS_OPTIONS = [
  { value: "", label: "ທັງໝົດ" },
  { value: "open", label: "ເປີດ" },
  { value: "investigating", label: "ກຳລັງກວດສອບ" },
  { value: "resolved", label: "ຕັດສິນແລ້ວ" },
  { value: "rejected", label: "ປະຕິເສດ" },
];

export function DisputesFilter() {
  const navigate = useNavigate({ from: "/app/disputes" });
  const search = useSearch({ from: "/app/disputes" }) as OffsetPageQueryDTO;

  const filters = search.filters ?? [];
  const statusFilter = filters.find(
    (f: { field: string }) => f.field === "status",
  );
  const currentStatus =
    (statusFilter as { value?: string } | undefined)?.value ?? "";

  const setFilter = (field: string, value: string) => {
    const rest = filters.filter((f: { field: string }) => f.field !== field);
    const next = value ? [...rest, { field, op: "eq" as const, value }] : rest;
    navigate({
      search: {
        ...search,
        offset: 0,
        filters: next.length ? next : undefined,
      },
    });
  };

  const clearFilters = () => {
    navigate({
      search: {
        ...search,
        offset: 0,
        filters: undefined,
      },
    });
  };

  const hasFilters = !!currentStatus;

  return (
    <div className="flex flex-wrap items-center gap-2 border-b px-4 pb-3">
      <Select
        value={currentStatus || "all"}
        onValueChange={(v) => setFilter("status", v === "all" ? "" : v)}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="ສະຖານະ" />
        </SelectTrigger>
        <SelectContent>
          {STATUS_OPTIONS.map((o) => (
            <SelectItem key={o.value || "all"} value={o.value || "all"}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {hasFilters && (
        <Button variant="ghost" size="sm" onClick={clearFilters}>
          ລ້າງຕົວກອງ
        </Button>
      )}
    </div>
  );
}
